import { render, staticRenderFns } from "./ArrivalOrders.vue?vue&type=template&id=5b62a31e&scoped=true"
import script from "./ArrivalOrders.vue?vue&type=script&lang=js"
export * from "./ArrivalOrders.vue?vue&type=script&lang=js"
import style0 from "./ArrivalOrders.vue?vue&type=style&index=0&id=5b62a31e&prod&lang=less&scoped=true"
import style1 from "./ArrivalOrders.vue?vue&type=style&index=1&id=5b62a31e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b62a31e",
  null
  
)

export default component.exports